import { AbstractControl, ValidatorFn, ValidationErrors } from "@angular/forms";

export class MyCustomValidators {
  static checkRepeatPassword(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control?.get("password")?.value;
      const confirmPassword = control?.get("password_repeat")?.value;
      if (password !== confirmPassword) {
        control.get("password_repeat")?.setErrors({ passwordRepeat: true });
        return { passwordRepeat: true };
      } else {
        control.get("password_repeat")?.setErrors(null);
        return null;
      }
    };
  }

  static isWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isWhitespace = (control.value || "").trim().length === 0;
      return isWhitespace ? { is_white_space: true } : null;
    };
  }

  static noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && /\s/.test(control.value)) {
        return { white_space: true };
      }
      return null;
    };
  }

  static isPhoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phoneNumberRegex = /^[0-9+]+$/;

      const isValidPhoneNumber = phoneNumberRegex.test(control.value);

      return isValidPhoneNumber ? null : { invalid_phone_number: true };
    };
  }
}
